module.exports = __webpack_public_path__ + "src/assets/img/hood.884ae362.svg";